import { ReactNode, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from "react-router-dom";

import { BLAdmin, EPermissions } from '../../../types/working-model';
import Icon, { COLORS, ICONS } from '../../general-ui/icon';
import { signOut } from '../../../store/actions/authentication';
import { AuthWrapper } from '../../admin/authentication/AuthWrapper';
import './profile-details.scss';
import { PATHNAMES } from '../../../utils/admin-routing-utils';
import { removeStorageItem } from '../../../utils/local-storage';
import { StoredTokens } from '../../../store/reducers/authentication';


interface Props {
	open: boolean;
	onClose?: () => void;
	children: ReactNode;
	style?: React.CSSProperties;
	account: BLAdmin;
	position?: string;
}

export function ProfileDetails({
	open,
	onClose,
	// children,
	style = {},
	account,
	position
}: Props): JSX.Element {
	const [isOpen, setIsOpen] = useState(open);
	const selector = useRef<HTMLDivElement | null>(null);

	const dispatch = useDispatch();

	useEffect(() => {
		setIsOpen(open);
	}, [open]);

	useEffect(() => {
		function checkClick(e: any) {
			const path = e.path || e.composedPath();
			for (const item of path) {
				if (selector.current === item) return;
			}
			setIsOpen(false);
			onClose && onClose();
		}

		if (isOpen) {
			window.addEventListener('click', checkClick);
		}

		return () => window.removeEventListener('click', checkClick);
	}, [isOpen, onClose]);

	function handleLogOut() {
		// THESE IS TEMPORARY. We are going to include the stored token when we have
		// two extra security measures in place
		removeStorageItem(StoredTokens.storedTwoFactor);
		removeStorageItem('currentChannel');
		removeStorageItem('admin_SSO_access');
		removeStorageItem('sso_admin_auth');
		removeStorageItem('auth_email');
		
		dispatch(signOut());
		window.zE.hide(); // hide the Zendesk support widget
	}

	return (
		<div
			className={`profile-details-wrapper ${isOpen ? "open" : ""} ${position === 'top' ? "top" : ""}`}
			style={style}
			ref={selector}
		>
			<ul>
				<div className="profile-details-top">
					<li className="profile-details-header">
						<Link to={PATHNAMES.AdminProfile}>
							<div className="profile-details-header-left">
								<span className="name">{account.profile?.first_name} {account.profile?.last_name}</span>
								<span>See your profile</span>
							</div>
							<div className="profile-details-header-right">
								<Icon name={ICONS.KEYBOARD_ARROW_RIGHT} size={12} color={COLORS.WHITE} />
							</div>
						</Link>
					</li>
				</div>
				<AuthWrapper allowedRoles={[EPermissions.Owner, EPermissions.Admin]}>
					<li>
						<Link to={PATHNAMES.IntegrationsLink}>
							<Icon name={ICONS.LAYOUT_GRID} size={16} color={COLORS.WHITE} />
							<span>{"Integrations"}</span>
						</Link>
					</li>
					<li>
						<Link to={PATHNAMES.SettingsLink}>
							<Icon name={ICONS.SETTINGS_TRANSPARENT} size={16} color={COLORS.WHITE} />
							<span>{"Settings"}</span>
						</Link>
					</li>
				</AuthWrapper>
				{/* FUTURE DEV - page is not being implemented for MVP but will be used in the future */}
				{/* <Link to={PATHNAMES.WhatsNew}>
					<li>
						<Icon name={ICONS.WHATS_NEW} size={16} color={COLORS.WHITE} />
						<span>{"What's new"}</span>
					</li>
				</Link> */}

				<li>
					<a href={PATHNAMES.Support} target="__blank" rel="noopener">
						<Icon name={ICONS.SUPPORT} size={16} color={COLORS.WHITE} />
						<span>{"Help & Support"}</span>
					</a>
				</li>
				<li>
					<button className="no-style" onClick={handleLogOut}>
						<Icon name={ICONS.LOG_OUT} size={16} color={COLORS.WHITE} />
						{"Log Out"}
					</button>
				</li>
			</ul>
		</div >
	);
}
